import React from "react"
import { IResourceComponentsProps, useShow } from "@refinedev/core"
import { Show, DateField } from "@refinedev/antd"
import { Avatar, Card, Col, Grid, Row, Space, Typography } from "antd"
import Editor from "@monaco-editor/react"
import { UserOutlined, CalendarOutlined } from "@ant-design/icons"

const { useBreakpoint } = Grid

const { Title } = Typography

export const JsonSchemaShow: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow()
  const { data, isLoading } = queryResult

  const { xl } = useBreakpoint()

  const record = data?.data

  return (
    <Show isLoading={isLoading}>
      <Row gutter={[16, 16]} style={{}}>
        <Col xl={6} lg={24} xs={24}>
          <Card
            bordered={false}
            style={{
              height: "100%",
            }}
          >
            <Space
              direction="vertical"
              style={{
                width: "100%",
                height: "100%",
              }}
            >
              <Space
                direction="vertical"
                style={{
                  textAlign: "center",
                  width: "100%",
                }}
              >
                <Avatar
                  size={120}
                  src={record?.avatar?.[0].url}
                  style={{
                    backgroundColor: "#fde3cf",
                  }}
                ></Avatar>
                <Typography.Title level={3}>{record?.name}</Typography.Title>
              </Space>
              <Space
                direction="vertical"
                style={{
                  width: "100%",
                  textAlign: xl ? "unset" : "center",
                }}
              >
                <Typography.Text>
                  <UserOutlined /> {`ID: ${record?.id}`}
                </Typography.Text>
                <Title level={5}>Created:</Title>
                <Typography.Text>
                  <CalendarOutlined /> <DateField value={record?.created_at} />
                </Typography.Text>
                <Title level={5}>Last Updated:</Title>
                <Typography.Text>
                  <CalendarOutlined /> <DateField value={record?.updated_at} />
                </Typography.Text>
              </Space>
            </Space>
          </Card>
        </Col>
        <Col xl={18} lg={24} xs={24}>
          <Editor
            height="550px"
            language="json"
            value={JSON.stringify(record?.content, null, 4)}
            options={{
              acceptSuggestionOnCommitCharacter: true,
              acceptSuggestionOnEnter: "on",
              accessibilitySupport: "auto",
              codeLens: true,
              colorDecorators: true,
              contextmenu: true,
              cursorBlinking: "blink",
              cursorStyle: "line",
              disableLayerHinting: false,
              disableMonospaceOptimizations: false,
              dragAndDrop: false,
              fixedOverflowWidgets: false,
              folding: true,
              foldingStrategy: "auto",
              fontLigatures: false,
              formatOnPaste: false,
              formatOnType: false,
              hideCursorInOverviewRuler: false,
              links: true,
              mouseWheelZoom: false,
              multiCursorMergeOverlapping: true,
              multiCursorModifier: "alt",
              overviewRulerBorder: true,
              overviewRulerLanes: 2,
              quickSuggestions: true,
              quickSuggestionsDelay: 100,
              renderControlCharacters: false,
              renderLineHighlight: "all",
              renderWhitespace: "none",
              revealHorizontalRightPadding: 30,
              roundedSelection: true,
              rulers: [],
              scrollBeyondLastColumn: 5,
              scrollBeyondLastLine: false,
              selectOnLineNumbers: true,
              selectionClipboard: true,
              selectionHighlight: true,
              smoothScrolling: false,
              suggestOnTriggerCharacters: true,
              wordBasedSuggestions: true,
              wordSeparators: "~!@#$%^&*()-=+[{]}|;:'\",.<>/?",
              wordWrap: "off",
              wordWrapBreakAfterCharacters: "\t})]?|&,;",
              wordWrapBreakBeforeCharacters: "{([+",
              wordWrapColumn: 80,
              wrappingIndent: "none",
              readOnly: true,
              lineNumbers: "on",
              automaticLayout: true,
              theme: "light",
              showFoldingControls: "always",
            }}
          />
        </Col>
      </Row>
    </Show>
  )
}
